import { schema } from 'normalizr';
import { DeviceDataAPIResponse } from '../device.model';
import { Base64 } from '../../../../util/Base64';

export const ProcessDeviceData = (device: DeviceDataAPIResponse) => {
  return {
    ...device,
    uuid: Base64.decode(device.uuid),
  };
};

const deviceSchema = new schema.Entity(
  'devices',
  {},
  {
    idAttribute: (value: DeviceDataAPIResponse) => Base64.decode(value.uuid),
    processStrategy: ProcessDeviceData,
  }
);

deviceSchema.define({
  childGroups: [deviceSchema],
});

export interface DeviceStructure {
  entities: {
    devices: Record<string, DeviceDataAPIResponse>;
  };
  result: string[];
}

export const deviceListSchema = new schema.Array(deviceSchema);
